// extracted by mini-css-extract-plugin
export default {"custom-mx-auto":"style_custom-mx-auto__Zb4M4"};